import axios from "axios";

const getAuthHeader = () => {
    const token = sessionStorage.getItem('token');
    const header = {
        headers: { 
            Authorization: "Bearer " + token
     }
    };
    return header;
}

export const getEncUrl=async(data)=>{
    const url=`${process.env.REACT_APP_API_URL}/api/ccavenue-payment`
    return axios.post(url,data,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const getStudyMatirialCCavenueApi=async(data)=>{
    const url=`${process.env.REACT_APP_API_URL}/api/ccavenue-studymaterial-payment`
    return axios.post(url,data,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const getEncUrlDhofar=async(data)=>{
    const url=`${process.env.REACT_APP_API_URL}/api/bankdofar-payment`
    return axios.post(url,data,getAuthHeader()).then((res)=>{
        return res.data
    })
}